// extracted by mini-css-extract-plugin
var _1 = "VtOX438RJAMkY0YAg0EX";
var _2 = "PE70oUSYzN8P7Z3WP9nP";
var _3 = "DH16qGFJq1VXPyZCMyWT";
var _4 = "ftFeuepgaCzYaq5rKLHx";
var _5 = "dark-mode";
var _6 = "FswGCLn9ShPMxQnxzqh5";
var _7 = "CmiTTyiJ9vlUwRNdzJyZ";
var _8 = "WWiNzhlpjTArGFbDTocd";
var _9 = "T7EZQTRILQZ3_rlKGy6E";
var _a = "JUQ6sH3T7tBsooDi0Q9k";
var _b = "w5Jxb30DxsfYb2pX2CNU";
var _c = "BSvK8Zhp1gy60na1rUNz";
var _d = "W0gyQWgckljrBKCRqTJz";
var _e = "b6fgaL37nYYWGhrdNwfi";
var _f = "CV4AMTPg6_VM_uvn6tmg";
var _10 = "l9UZ6354b2Dd04DxecY7";
var _11 = "NuzXzeihVoLiuyHCObPO";
var _12 = "HblSnsBj_IpDzfO4l8Vi";
export { _1 as "action", _2 as "actions", _3 as "appear", _4 as "busy", _5 as "dark-mode", _6 as "destructive", _7 as "dialog", _8 as "icon", _9 as "label", _a as "main", _b as "message", _c as "primary", _d as "prominent", _e as "spinner", _f as "standalone", _10 as "title", _11 as "wide", _12 as "wrapper" }
